import { type MyUserFieldsFragment, UserLicenseTypeEnum } from '@salescore/client-api'

export const checkSyncEnabled = (myUser: Pick<MyUserFieldsFragment, 'role' | 'userLicenses'>): boolean =>
  myUser.role === 'admin' || myUser.userLicenses.some((x) => x.license === UserLicenseTypeEnum.Sync)

export const checkVisualizeEnabled = (myUser: Pick<MyUserFieldsFragment, 'role' | 'userLicenses'>): boolean =>
  myUser.role === 'admin' || myUser.userLicenses.some((x) => x.license === UserLicenseTypeEnum.Visualize)
